<template>
    <div :style="{'max-width': '1300px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px', 'padding-bottom': '100px'}">
        <b-card style="padding: 5px;" class="hidden-print">
            <h5>Process Refunds</h5>
            <!-- <div>
                <b-form @submit="search_sales">
                    
                    <div style="display: inline-block; vertical-align: top;">
                        <div>
                            <b-form-input style="width: 200px; display: inline-block;" v-model="query" type="text" required></b-form-input>
                        </div>
                        <sub>Enter invoice # / email / customer phone</sub>
                    </div>
                    <div style="display: inline-block; vertical-align: top;">
                        <b-button size="md" type="submit" variant="primary">Search</b-button>
                    </div>
                </b-form>
            </div> -->
        </b-card>

        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">

            <b-card v-if="items.length == 0" style="width: 100%;">
                <b-alert show variant="warning">Nothing to show</b-alert>
            </b-card>

            <b-card v-else style="width: 100%;">
                <table class="text-monospace" style="width: 100%;">
                    <thead>
                        <tr style="background: #c3cdd3;">
                            <td class="ipt_tdhr">
                                INVOICE ID
                            </td>
                            <td class="ipt_tdhr">
                                PRODUCT
                            </td>
                            <td class="ipt_tdhr">
                                REQUEST DATETIME
                            </td>
                            <td class="ipt_tdhr">
                                RETURNED QTY
                            </td>
                            <td class="ipt_tdhr">
                                RECEIVED QTY
                            </td>
                            <td class="ipt_tdhr">
                                STATUS
                            </td>
                            <td class="ipt_tdhr">
                                ACTION
                            </td>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="item,idx in items" v-bind:key="idx">
                            <td class="ipt_tdhr">
                                {{item.invoice_id}}
                            </td>
                            <td class="ipt_tdhr">
                                {{item.product_sku}}
                            </td>
                            <td class="ipt_tdhr">
                                {{item.ts}}
                            </td>
                            <td class="ipt_tdhr">
                                {{item.refund_quantity}}
                            </td>
                            <td class="ipt_tdhr">
                                {{(item.received_quantity || 0 )}}
                            </td>
                            <td class="ipt_tdhr">
                                <b-form-select :options="refund_approvals" v-model="item.approved" size="sm" style="width: 150px;">
                                </b-form-select>
                            </td>
                            <td class="ipt_tdhr">
                                <b-button size="sm" variant="success">SAVE</b-button>
                                <b-button size="sm" variant="outline-primary">VIEW DETAILS</b-button>
                                
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
    import _ from 'underscore'
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    export default {
        name: "ProcessRefunds",
        components: {Backer},
        data: function(){
            return {
                packet: {},
                query: null,
                invoices: [],
                invoice: {items: []},
                invoice_id: null,
                items_being_loaded: false,
                message: "No invoice loaded",
                items: [],
                refund_being_generated: false,
                existing_refunds: [],
                conditions: [
                    {value: 1, text: "New"},
                    {value: 2, text: "Open Box"},
                    {value: 3, text: "Damaged"},
                    {value: 4, text: "Never Delivered"}
                ],
                refund_payment_modes: [
                    {value: 1, text: "Credit Card"},
                    {value: 2, text: "Cash"},
                    {value: 3, text: "Store Credit"}
                ],
                refund_approvals: [
                    {value: null, text: "Pending" },
                    {value: 1, text: "Approved" },
                    {value: 2, text: "Denied" },
                ],
                refund_elements: []
            }
        },
        methods: {
            navigateToInvoice: function(invoice_id){
                let route = this.$router.resolve({path: "/sales/viewsale/"+invoice_id+"/"});
                window.open(route.href, '_blank');
            },
            get_refund_amount: function(ritem){
                let item = this.invoice.items.filter(function(d){
                    return d.product_sku == ritem.product_sku
                })
                let refund_amount = 0.0;
                if (item.length> 0){
                    item = item[0];
                    refund_amount = (((parseFloat(item.total) * 0.10) + parseFloat(item.total) ) / (parseInt(item.quantity))) * (parseInt(ritem.refund_quantity) || 0)
                }
                return refund_amount
            },
            
            saveRefund: function(ritem){
                
                let path = "/api/sales/save_refund/"
                let data = ritem;
                data.refunding_user = this.packet.userDetails.username;
                data.refund_amount = this.get_refund_amount(ritem);
                let that = this;
                
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Created a refund.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );

                        ritem.ts = response.data.result[0].ts;
                    }
                    that.refund_being_generated = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "Error generatung refund(s). Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.refund_being_generated = false;
                }
                this.refund_being_generated = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            removeRefund: function(ritem, ridx) {
                let path = "/api/sales/delete_refund/"
                let data = ritem;
                let that = this;

                if (!ritem.id){
                    this.refund_elements.splice(ridx, 1);
                    return
                }

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Deleted a refund.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );

                        that.refund_elements.splice(ridx, 1);
                    }
                    that.refund_being_generated = false;
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "Error generatung refund(s). Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.refund_being_generated = false;
                }
                this.refund_being_generated = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            search_sales: function(e){
                if (e){
                    e.preventDefault();
                }

                if (!this.query){
                    this.$vex.dialog.alert({message: "Please enter a valid search term."})
                    return
                }

                let path = "/api/sales/get_sales/"
                //this.search_term = this.search_term.replace(/\s+$/,"").replace(/^\s+/,"");
                let data = {query: {invoice_id: this.query.replace(/\s+$/,"").replace(/^\s+/,"")}, userid: this.packet.userDetails.id}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.invoices = response.data.result
                        
                        if (that.invoices.length <= 0){
                            that.message = "No invoices found."
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading invoice. Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded=true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_init: function(e){
                if (e){
                    e.preventDefault();
                }

                let path = "/api/sales/get_refunds_list/"
                let data = {location_id: (this.packet.userDetails.properties||{}).location_id}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result
                        
                        if (that.items.length <= 0){
                            that.message = "No refunds found."
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading refunds. Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded=true;
                Requestor.getSyncP(path, data, this, s, f);

            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_init()
        }
    }
</script>

<style scoped>
    td {
        border: 1px solid gray;
        font-size: 14px;
    }

    .input-txt {
        border: 0px; 
        font-weight: normal; 
        color: #2c3e50; 
        display: inline; 
        padding: 0px; 
        margin: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Sales/ProcessRefunds.vue